/**
 * Created by zhj on 3/14/2016.
 */
'use strict';

angular.module('telephone')
  .controller('TelephoneCtrl', function ($scope, $rootScope, telephoneService, commonTrackService, $uibModal, $state, $translate, $timeout, toastService, $window, widgetSettingsCreatorService) {
    $scope.overviewGridPrefix = commonTrackService.getOverviewGridPrefix();
    $scope.isDataAvailable = false;
    $scope.hasUpdateRight = false;
    $scope.telephondeResourceAcl = null;
    $scope.pendingCommandsAcl = null;
    $scope.telephoneListDetails = {
      selectedFunction:''
    };

    // var downloadFunction = function () {
    //   $uibModal.open({
    //     templateUrl: 'components/track/telephone/download.tpl.html',
    //     controller: 'PendingCommandCtrl'
    //   });
    // };

    var deleteTel = function () {
      var rowindex = $('#' + $scope.overviewGridPrefix + 'telephonesList').jqxGrid('getselectedrowindex');
      var data = $('#' + $scope.overviewGridPrefix + 'telephonesList').jqxGrid('getrowdata', rowindex);
      var modalInstance = $uibModal.open({
        templateUrl: 'components/track/telephone/deleteConfirm.tpl.html',
        controller: 'DeleteCtrl',
        resolve: {
          selectedRowData: function () {
            return data;
          }
        }
      });

      modalInstance.result.then(function (result) {
        if (result === 'success') {
          var rowindex = $('#' + $scope.overviewGridPrefix + 'telephonesList').jqxGrid('getselectedrowindex');
          if (rowindex > -1) {
            var id = $('#' + $scope.overviewGridPrefix + 'telephonesList').jqxGrid('getrowid', rowindex);
            $('#' + $scope.overviewGridPrefix + 'telephonesList').jqxGrid('deleterow', id);
          }
        } else if (result === 'error') {
          console.error('delete error');
        }
      });
    };

    var importFunction = function () {
      var modalInstance = $uibModal.open({
        templateUrl: 'components/track/telephone/telephoneImportDialog.tpl.html',
        controller: 'ImportDilaogCtrl'
      });

      modalInstance.result.then(function (result) {
        toastService.showSuccessToast(result);
        $timeout(function () {
          $window.location.reload();
        }, 400);
      });

    };


     $scope.moreFunctionsSource = [
    //  {
    //   name: $translate.instant('moreFunction.functionList.download'),
    //   operation: 'download',
    //   disabled: true,
    //   execute: downloadFunction
    // },
    {
      name: $translate.instant('moreFunction.functionList.delete'),
      operation: 'delete',
      disabled: true,
      execute: deleteTel
    }, {
      name: $translate.instant('moreFunction.functionList.fileImport'),
      operation: 'import',
      disabled: true,
      execute: importFunction
    }];

    $scope.moreFuctionSetting = {
      placeHolder: $translate.instant('moreFunction.button.function'),
      displayMember: 'name',
      valueMember: 'operation',
      source: $scope.moreFunctionsSource,
      theme: widgetSettingsCreatorService.fetchWidgetStyleSettings().theme, //'material', // theme: 'bootstrap',
      width: '200px',
      height: 30,
      autoDropDownHeight: true
    };

    $scope.moreFunctions = function () {
      for (var index in $scope.moreFunctionsSource) {
        var moreFunctionsItem = $scope.moreFunctionsSource[index];
        if (moreFunctionsItem.operation && moreFunctionsItem.operation === $scope.telephoneListDetails.selectedFunction.operation) {
          moreFunctionsItem.execute();
          $scope.telephoneListDetails.selectedFunction = '';
          break;
        }
      }
      $('#moreFunDropDown').jqxDropDownList('clearSelection');
    };

    var _tmpColumnProperties = [{
      name: 'name', width: '25%',
      type: 'string'
    }, {
      name: 'telephoneNumber', width: '25%',
      type: 'string'
    }];

    $scope.customGridProperties = {
      pagesize: 25,
      height: 600,
      autoheight: false,
      showfilterrow: true,
      filterable: true,
      columns: []
    };

    $scope.customGridProperties.columns = commonTrackService.getColumnProperties(_tmpColumnProperties, {}, {moduleName: 'telephones'});
    var _additionalProperties = {translatedName: $translate.instant('telephonesList.moduleName')};
    $scope.telephonesListGridSettings = commonTrackService.getGridSettings('telephones', $scope.customGridProperties, null, _additionalProperties);

    var getTelephoneList = function () {
      return telephoneService.getTelephoneList().then(function (telephoneIndexes) {
        $scope.isDataAvailable = true;
        var _tmpDetail = [];
        for (var i = 0; i < telephoneIndexes.length; i++) {
          var telephone = telephoneIndexes[i];
          var _detailObjFormat = {
            key: telephone.key,
            name: telephone.name,
            telephoneNumber: telephone.telephoneNumber
          };
          _tmpDetail.push(_detailObjFormat);
        }
        $scope.telephonesListGridSettings.source = _tmpDetail;

      }, function (response) {
        if (response.data && response.data.message) {
          $scope.isDataAvailable = false;
        }
      });
    };

    var pendingCommandsAclRight = function () {
      return telephoneService.getPendingCommandsAclRight().then(function (pendingCommandsAclRights) {
        $scope.pendingCommandsAcl = pendingCommandsAclRights;
      });
    };


    var telpehoneResourceAclRight = function () {
      return telephoneService.getTelephoneAclRight().then(function (telephondeAclRights) {
        $scope.telephondeResourceAcl = telephondeAclRights;
      });
    };

    telpehoneResourceAclRight().then(function () {
      return getTelephoneList();
    }).then(function () {
      return pendingCommandsAclRight();
    }).finally(function () {
      if ($scope.isDataAvailable) {
        if ($scope.telephondeResourceAcl&&$scope.telephondeResourceAcl.aclRightLvel === 3) {
          enableDropDoen(0); // delete  menu index 1
          enableDropDoen(1); // import menu index 2
        } else {
          disabbleDropDown(0);// delete menu index 1
          disabbleDropDown(1);// import menu index 2
        }
        // if ($scope.pendingCommandsAcl && $scope.pendingCommandsAcl.aclRightLvel === 3) {
        //   enableDropDoen(0); // download menu index 0
        // }
        // else {
        //   disabbleDropDown(0);// download menu index 0
        // }
      }

      $scope.dataLoadingFinished = true;

      if ($scope.telephondeResourceAcl.aclRightLvel > 0) {
        enableDoubleClickEvent();
      }
    });

    function enableDropDoen(index) {
      $timeout(function () {
        $('#moreFunDropDown').jqxDropDownList('enableAt', index); // this does not working check onece more
      });
    }

    function disabbleDropDown(index) {
      $timeout(function () {
        $('#moreFunDropDown').jqxDropDownList('disableAt', index); // this does not working check onece more
      });
    }


    function enableDoubleClickEvent() {
      $timeout(function () {
        $('#' + $scope.overviewGridPrefix + 'telephonesList').on('rowdoubleclick', function () {
          $scope.toEditPage();
        });
      }, 0);
    }

    $scope.toEditPage = function () {
      var rowindex = $('#' + $scope.overviewGridPrefix + 'telephonesList').jqxGrid('getselectedrowindex');
      if (rowindex !== -1) {
        var data = $('#' + $scope.overviewGridPrefix + 'telephonesList').jqxGrid('getrowdata', rowindex);
        $state.go('telephones.edit', data);
      } else {
        toastService.showWarningToast('No Selected Item!');
      }
    };

    $scope.new = function () {
      $state.go('telephones.new');
    };

    $scope.copy = function () {
      var rowindex = $('#' + $scope.overviewGridPrefix + 'telephonesList').jqxGrid('getselectedrowindex');
      if (rowindex !== -1) {
        var data = $('#' + $scope.overviewGridPrefix + 'telephonesList').jqxGrid('getrowdata', rowindex);
        $state.go('telephones.copy', data);
      } else {
        toastService.showWarningToast('No Selected Item!');
      }
    };

    $scope.$on('$destroy', function () {
      delete  $scope.telephonesListGridSettings.source;
    });
  });



// WEBPACK FOOTER //
// ./.tmp/components/track/telephone/telephoneListController.js